const mod = (n, m) => ((n % m) + m) % m;
const map = (x, a, b, c, d) => ((x - a) * (d - c)) / (b - a) + c;
const clamp = (val, min = 0, max = 1) => Math.max(min, Math.min(max, val));

export { mod, map, clamp };
